import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'modules/i18n';
import { TaskRoutesConfig } from 'modules/task';

import emptyImage from '../../assets/empty.png';
import translation from './empty.translation';

export function Empty(): JSX.Element {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);

  return (
    <div className={classes.empty}>
      <img className={classes.emptyImage} src={emptyImage} alt="" />

      <Typography variant="h6">{t(keys.empty)}</Typography>

      <Button
        type="button"
        size="large"
        onClick={() => navigate(TaskRoutesConfig.createTask.generatePath())}
        className={classes.button}
      >
        {t(keys.createTask)}
      </Button>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(8),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },

  button: {
    '&&': {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },

  emptyImage: {
    width: 200,
  },
}));
